import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  DatePicker,
} from '@material-ui/pickers';
import enLocale from 'date-fns/locale/en-US';
import idLocale from 'date-fns/locale/id';
import { AppState } from '../../state/MyStateProvider';
import BootstrapInput from './BootstrapInput';

const useStyles = makeStyles((theme) => ({
  input: {
    borderColor: (props) => (props.error ? theme.palette.error.main : '#ced4da'),
  },
}));

const MyInputDate = (props) => {
  const {
    name,
    value,
    onChange,
    defaultValue,
    inputRef,

    views,

    autoFocus,
    disabled,
    error,
    required,
  } = props;
  const classes = useStyles({ error });

  const { state } = React.useContext(AppState);

  const localeMap = {
    en: enLocale,
    id: idLocale,
  };

  const [internalValue, setInternalValue] = React.useState(defaultValue);

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[state.lang]}>
      <DatePicker
        autoFocus={autoFocus}
        inputRef={inputRef}
        required={required}
        disabled={disabled}
        id={name}
        format={views ? undefined : 'dd/MM/yyyy'}
        views={views || ['year', 'month', 'date']}
        value={onChange ? value : internalValue}
        onChange={(newValue) => {
          if (!onChange) {
            setInternalValue(newValue);
          } else {
            onChange({
              skipPersist: true,
              target: {
                name,
                value: newValue,
              },
            });
          }
        }}
        cancelLabel="Cancel"
        TextFieldComponent={({ helperText, InputProps, ...textFieldProps }) => (
          <BootstrapInput classes={{ input: classes.input }} {...textFieldProps} />
        )}
      />
    </MuiPickersUtilsProvider>
  );
};

MyInputDate.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  onChange: PropTypes.func,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  inputRef: PropTypes.any,

  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  required: PropTypes.bool,

  views: PropTypes.arrayOf(PropTypes.string),
};

MyInputDate.defaultProps = {
  onChange: undefined,
  value: undefined,
  defaultValue: undefined,
  inputRef: undefined,

  autoFocus: false,
  disabled: false,
  error: false,
  required: false,

  views: undefined,
};

export default MyInputDate;
